import { formatNumberWithCommas } from "utils";
import { roundBudgetMoney } from "./budgetFringeTotals";

/**
 * Budget money in exact cents, e.g. `$230,290.85`, so summaries match the budget table.
 * `emptyIfNoValue` blanks zero, for amounts that are optional rather than computed.
 */
export const formatBudgetMoney = (
  currencySymbol: string,
  value: number,
  emptyIfNoValue = false
): string => `${currencySymbol}${formatNumberWithCommas(roundBudgetMoney(value), emptyIfNoValue)}`;
